import React from 'react';
import { Hero } from '../components/Hero';
import { ValueBar } from '../components/ValueBar';
import { Banner } from '../components/Banner';
import { ProblemSection } from '../components/ProblemSection';
import { WhatIDo } from '../components/WhatIDo';
import { Differences } from '../components/Differences';
import { PackageSection } from '../components/PackageSection';
import { Testimonials } from '../components/Testimonials';
import { Philosophy } from '../components/Philosophy';
import { About } from '../components/About';
import { Resources } from '../components/Resources';
import { WhoItsFor } from '../components/WhoItsFor';
import { FinalCTA } from '../components/FinalCTA';
export function Home() {
  return <>
      <Hero data-id="element-309" />
      <ValueBar data-id="element-310" />
      <Banner data-id="element-311" />
      <ProblemSection data-id="element-312" />
      <WhatIDo data-id="element-313" />
      <Differences data-id="element-314" />
      <PackageSection data-id="element-315" />
      <Testimonials data-id="element-316" />
      <Philosophy data-id="element-317" />
      <About data-id="element-318" />
      <Resources data-id="element-319" />
      <WhoItsFor data-id="element-320" />
      <FinalCTA data-id="element-321" />
    </>;
}